import React, {Component} from "react";
import SimpleUploadImage from "../../../../../modules/upload/SimpleUploadImage";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import {leasingPaymentStatus} from "../config";
import {FormatCurrencyWithoutSymbol} from "../../../../../Services/Utils";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import moment from "moment";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import FlexView from "react-flexview";
import * as R from "ramda";

class DataPenagihanTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cancelAlert: false,
            bbm: null,
        }
    };

    handleCancelAlert = (bbm) => {
        this.setState((prevValue) => ({...prevValue, cancelAlert: !prevValue.cancelAlert, bbm}));
    };

    handleUncheckedBbm = () => {
        let {bbm} = this.state;
        this.props.handleUncheckBbm(bbm);
        this.handleCancelAlert(null);
    };

    render() {
        const isEditBelumPenagihan =
            (this.props.tab === leasingPaymentStatus.BELUM_PENAGIHAN || this.props.tab === leasingPaymentStatus.SUDAH_PENAGIHAN) && this.props.isUpdateActivity;
        const isPreviewTabPenagihan =
            (this.props.tab === leasingPaymentStatus.BELUM_PENAGIHAN || this.props.tab === leasingPaymentStatus.SUDAH_PENAGIHAN) && !this.props.isUpdateActivity;
        return(
            <>
                <div className="grid grid-2x grid-mobile-none gap-15px">
                    <SimpleInput
                      id="input_text_harga_otr"
                      name="hargaOTR"
                      box="onlyNumber"
                      label="Harga OTR/Off"
                      readOnly
                      value={FormatCurrencyWithoutSymbol({
                        number: this.props.data?.hargaOtr,
                      })}
                    />
                    <SimpleInput
                      id="input_text_dp_po"
                      name="dpPO"
                      label="DP PO"
                      box="onlyNumber"
                      readOnly
                      value={FormatCurrencyWithoutSymbol({
                        number: this.props.data?.dpPO,
                      })}
                    />
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px">
                    <SimpleInput
                        id="input_text_harga_diberikan"
                        name="hargaDiberikan"
                        box="onlyNumber"
                        label="Harga Diberikan"
                        readOnly
                        value={FormatCurrencyWithoutSymbol({number:this.props.data?.hargaDiberikan})}
                    />
                    <SimpleInput
                        id="input_text_angsuran"
                        name="angsuran"
                        label="Angsuran"
                        box="onlyNumber"
                        readOnly
                        value={FormatCurrencyWithoutSymbol({number:this.props.data?.nominalAngsuran})}
                    />
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px">
                    <SimpleInput
                        id="input_text_sales_program"
                        name="salesProgram"
                        label="Sales Program"
                        readOnly
                        value={this.props.data?.salesProgram}
                    />
                    <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                        <SimpleInput
                            containerclassname="flex-1"
                            id="input_text_tenor"
                            name="tenor"
                            label="Tenor"
                            box="onlyNumber"
                            readOnly
                            maxLength={3}
                            value={this.props.data?.tenor}
                        />
                        <p>Bulan</p>
                    </div>
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px">
                    <SimpleInput
                        id="input_text_subsidi"
                        name="subsidi"
                        box="onlyNumber"
                        label="Subsidi UM Leasing"
                        readOnly
                        value={FormatCurrencyWithoutSymbol({number:this.props.data?.subsidiLeasing})}
                    />
                    <SimpleInput
                        id="input_text_jasa"
                        name="jasa"
                        label="Jasa Perantara (TAC)"
                        box="onlyNumber"
                        readOnly
                        value={FormatCurrencyWithoutSymbol({number: this.props.data?.jumlahJptac})}
                    />
                </div>
                {
                    !this.props.isTabPelunasan ? (
                        <>
                            <div className="grid grid-2x grid-mobile-none gap-15px">
                                <SimpleInput
                                    id="input_text_lain"
                                    name="leasingOtherPayment"
                                    box="number"
                                    label="Lain-lain"
                                    onValueChange={({value}) => this.props.onValueChange("leasingOtherPayment", Number(value))}
                                    readOnly={isPreviewTabPenagihan}
                                    value={this.props.data?.leasingOtherPayment}
                                />
                                <SimpleInput
                                    containerclassname="flex-1"
                                    id="input_text_jp_tac_1"
                                    name="jpTac1Amount"
                                    label="JP/TAC 1"
                                    mandatory
                                    box="number"
                                    readOnly={!isEditBelumPenagihan}
                                    value={this.props.data?.jpTac1Amount}
                                    onValueChange={({value}) => this.props.onValueChange("jpTac1Amount", Number(value))}
                                    errorMessage={this.props.errors?.jpTac1Amount}
                                />
                            </div>
                            <div className="grid grid-2x grid-mobile-none gap-15px">
                                <div/>
                                <SimpleInput
                                    containerclassname="flex-1"
                                    id="input_text_jp_tac_2"
                                    name="jpTac2Amount"
                                    label="JP/TAC 2"
                                    box="number"
                                    mandatory={this.props.mandatory}
                                    readOnly={!isEditBelumPenagihan}
                                    value={this.props.data?.jpTac2Amount}
                                    onValueChange={({value}) => this.props.onValueChange("jpTac2Amount", Number(value))}
                                    errorMessage={this.props.errors?.jpTac2Amount}
                                />
                            </div>
                            <div className="grid grid-2x grid-mobile-none gap-15px">
                                <div/>
                                <SimpleInput
                                    containerclassname="flex-1"
                                    id="input_text_jp_tac_3"
                                    name="jpTac3Amount"
                                    label="JP/TAC 3"
                                    box="number"
                                    mandatory={this.props.mandatory}
                                    readOnly={!isEditBelumPenagihan}
                                    value={this.props.data?.jpTac3Amount}
                                    onValueChange={({value}) => this.props.onValueChange("jpTac3Amount", Number(value))}
                                    errorMessage={this.props.errors?.jpTac3Amount}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="grid grid-2x grid-mobile-none gap-15px">
                                <div/>
                                <SimpleInput
                                    id="input_text_jasa"
                                    name="jasa"
                                    label="Jasa Perantara (TAC) Transfer"
                                    box="number"
                                    readOnly
                                    value={this.props.data?.jumlahJpTacTransfer}
                                />
                            </div>
                            <div className="grid grid-2x grid-mobile-none gap-15px">
                                <div className="grid grid-2x grid-mobile-none gap-15px">
                                    <SimpleInput
                                        id="input_text_lain"
                                        name="leasingOtherPayment"
                                        box="number"
                                        label="Lain-lain"
                                        onValueChange={({value}) => this.props.onValueChange("leasingOtherPayment", Number(value))}
                                        readOnly={!isEditBelumPenagihan}
                                        value={this.props.data?.leasingOtherPayment}
                                    />
                                    <SimpleInput
                                        id="input_text_lain"
                                        name="leasingOtherTransferredPayment"
                                        box="number"
                                        label="Lain-lain Transfer"
                                        onValueChange={({value}) => this.props.onValueChange("leasingOtherTransferredPayment", Number(value))}
                                        readOnly={isPreviewTabPenagihan}
                                        value={this.props.data?.leasingOtherTransferredPayment}
                                    />
                                </div>
                                <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                                    <SimpleInput
                                        id="input_text_bbm_jp_tac_lain_lain"
                                        containerclassname="flex-1"
                                        name="bbmJpLainLain"
                                        label="Nomor BBM Lain-Lain"
                                        readOnly
                                        value={this.props.data?.leasingOtherTransferredBbm}
                                    />
                                    <SimpleButton
                                        category="action_button"
                                        disabled={!this.props.isUpdateActivity}
                                        styles={{
                                            fontSize: 20,
                                        }}
                                        onClick={() => this.props.handleOpenBBM("leasingOtherTransferredBbm")}
                                        icon={<i class="fa fa-search color-red"></i>}
                                    />
                                    <SimpleCheckBox
                                        id="checkbox_lunas_jp_tac_lain_lain"
                                        label="LUNAS"
                                        disabled={!this.props.data.leasingOtherTransferredBbm}
                                        checked={this.props.data?.leasingOtherTransferredBbm !== null}
                                        onChange={() => this.handleCancelAlert("leasingOtherTransferredBbm")}
                                    />
                                </div>
                            </div>
                            <div className="grid grid-2x grid-mobile-none gap-15px">
                                <div className="grid grid-2x grid-mobile-none gap-15px">
                                    <SimpleInput
                                        containerclassname="flex-1"
                                        id="input_text_jp_tac_1"
                                        name="jpTac1Amount"
                                        label="JP/TAC 1"
                                        mandatory
                                        box="number"
                                        readOnly={!isEditBelumPenagihan}
                                        value={this.props.data?.jpTac1Amount}
                                        onValueChange={({value}) => this.props.onValueChange("jpTac1Amount", value)}
                                        errorMessage={this.props.errors?.jpTac1Amount}
                                    />
                                    <SimpleInput
                                        containerclassname="flex-1"
                                        id="input_text_jp_tac_1"
                                        name="jpTac1TransferredAmount"
                                        label="JP/TAC 1 Transfer"
                                        mandatory
                                        box="number"
                                        readOnly={isPreviewTabPenagihan}
                                        value={this.props.data?.jpTac1TransferredAmount}
                                        onValueChange={({value}) => this.props.onValueChange("jpTac1TransferredAmount", Number(value))}
                                        errorMessage={this.props.errors?.jpTac1TransferredAmount}
                                    />
                                </div>
                                <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                                    <SimpleInput
                                        id="input_text_bbm_jp_tac_lain_lain"
                                        containerclassname="flex-1"
                                        name="bbmJpLainLain"
                                        label="Nomor BBM JP/TAC 1"
                                        readOnly
                                        value={this.props.data?.jpTac1Bbm}
                                    />
                                    <SimpleButton
                                        category="action_button"
                                        disabled={!this.props.isUpdateActivity}
                                        styles={{
                                            fontSize: 20,
                                        }}
                                        onClick={() => this.props.handleOpenBBM("jpTac1Bbm")}
                                        icon={<i class="fa fa-search color-red"></i>}
                                    />
                                    <SimpleCheckBox
                                        id="checkbox_lunas_jp_tac_1"
                                        label="LUNAS"
                                        disabled={!this.props.data.jpTac1Bbm}
                                        checked={this.props.data?.jpTac1Bbm !== null}
                                        onChange={() => this.handleCancelAlert("jpTac1Bbm")}
                                    />
                                </div>
                            </div>
                            <div className="grid grid-2x grid-mobile-none gap-15px">
                                <div className="grid grid-2x grid-mobile-none gap-15px">
                                    <SimpleInput
                                        containerclassname="flex-1"
                                        id="input_text_jp_tac_2"
                                        name="jpTac2Amount"
                                        label="JP/TAC 2"
                                        box="number"
                                        mandatory={this.props.mandatory}
                                        readOnly={!isEditBelumPenagihan}
                                        value={this.props.data?.jpTac2Amount}
                                        onValueChange={({value}) => this.props.onValueChange("jpTac2Amount", Number(value))}
                                        errorMessage={this.props.errors?.jpTac2Amount}
                                    />
                                    <SimpleInput
                                        containerclassname="flex-1"
                                        id="input_text_jp_tac_2"
                                        name="jpTac2TransferredAmount"
                                        label="JP/TAC 2 Transfer"
                                        box="number"
                                        mandatory={this.props.mandatory}
                                        readOnly={isPreviewTabPenagihan}
                                        value={this.props.data?.jpTac2TransferredAmount}
                                        onValueChange={({value}) => this.props.onValueChange("jpTac2TransferredAmount", Number(value))}
                                        errorMessage={this.props.errors?.jpTac2TransferredAmount}
                                    />
                                </div>
                                <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                                    <SimpleInput
                                        containerclassname="flex-1"
                                        id="input_text_bbm_jp_tac_2"
                                        name="bbmJp2"
                                        label="Nomor BBM JP/TAC 2"
                                        readOnly
                                        value={this.props.data?.jpTac2Bbm}
                                    />
                                    <SimpleButton
                                        category="action_button"
                                        disabled={!this.props.isUpdateActivity}
                                        styles={{
                                            fontSize: 20,
                                        }}
                                        onClick={() => this.props.handleOpenBBM("jpTac2Bbm")}
                                        icon={<i class="fa fa-search color-red"></i>}
                                    />
                                    <SimpleCheckBox
                                        id="checkbox_lunas_jp_tac_2"
                                        label="LUNAS"
                                        disabled={!this.props.data.jpTac2Bbm}
                                        checked={this.props.data?.jpTac2Bbm !== null}
                                        onChange={() => this.handleCancelAlert("jpTac2Bbm")}
                                    />
                                </div>
                            </div>
                            <div className="grid grid-2x grid-mobile-none gap-15px">
                                <div className="grid grid-2x grid-mobile-none gap-15px">
                                    <SimpleInput
                                        containerclassname="flex-1"
                                        id="input_text_jp_tac_3"
                                        name="jpTac3Amount"
                                        label="JP/TAC 3"
                                        box="number"
                                        mandatory={this.props.mandatory}
                                        readOnly={!isEditBelumPenagihan}
                                        value={this.props.data?.jpTac3Amount}
                                        onValueChange={({value}) => this.props.onValueChange("jpTac3Amount", Number(value))}
                                        errorMessage={this.props.errors?.jpTac3Amount}
                                    />
                                    <SimpleInput
                                        containerclassname="flex-1"
                                        id="input_text_jp_tac_3"
                                        name="jpTac3TransferredAmount"
                                        label="JP/TAC 3 Transfer"
                                        box="number"
                                        mandatory={this.props.mandatory}
                                        readOnly={isPreviewTabPenagihan}
                                        value={this.props.data?.jpTac3Amount}
                                        onValueChange={({value}) => this.props.onValueChange("jpTac3TransferredAmount", Number(value))}
                                        errorMessage={this.props.errors?.jpTac3TransferredAmount}
                                    />
                                </div>
                                <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                                    <SimpleInput
                                        containerclassname="flex-1"
                                        id="input_text_bbm_jp_tac_3"
                                        name="bbmJp3"
                                        label="BBM JP/TAC 3"
                                        readOnly
                                        value={this.props.data?.jpTac3Bbm}
                                    />
                                    <SimpleButton
                                        category="action_button"
                                        disabled={!this.props.isUpdateActivity}
                                        styles={{
                                            fontSize: 20,
                                        }}
                                        onClick={() => this.props.handleOpenBBM("jpTac3Bbm")}
                                        icon={<i class="fa fa-search color-red"></i>}
                                    />
                                    <SimpleCheckBox
                                        id="checkbox_lunas_jp_tac_3"
                                        label="LUNAS"
                                        disabled={!this.props.data.jpTac3Bbm}
                                        checked={this.props.data?.jpTac3Bbm !== null}
                                        onChange={() => this.handleCancelAlert("jpTac3Bbm")}
                                    />
                                </div>
                            </div>
                        </>
                    )
                }
                <div className="grid grid-2x grid-mobile-none gap-15px">
                    <div id="image_grid-1">
                        <SimpleUploadImage
                            downloadedFileName={`${moment().format('YYYYMMDD')}_GES_${this.props.dataCustomer?.namaPembeli}`}
                            id="input_upload_gesekan"
                            name="gesekan"
                            label="Foto Gesekan"
                            category={this.props.isTabPelunasan ? "" : "download"}
                            value={this.props.data?.fotoGesekanBase64}
                        />
                        <SimpleUploadImage
                            downloadedFileName={`${moment().format('YYYYMMDD')}_BAST_${this.props.dataCustomer?.namaPembeli}`}
                            id="input_upload_bast_smh"
                            name="fotoBastSmhBase64"
                            label="Foto Bast SMH"
                            mandatory
                            category={
                                this.props.isTabPelunasan
                                    ? ""
                                    : this.props.isViewActivity || this.props.isCancelActivity
                                        ? "download"
                                        : "download-upload"
                            }
                            value={this.props.data?.fotoBastSmhBase64}
                            errorMessage={this.props.errors.fotoBastSmhBase64}
                            onChange={(value, name) => this.props.onValueChange(name, value)}
                        />
                    </div>
                    <div id="image_grid-2">
                        <SimpleUploadImage
                            downloadedFileName={`${moment().format('YYYYMMDD')}_SER_${this.props.dataCustomer?.namaPembeli}`}
                            id="input_upload_penyerahan_unit"
                            name="penyerahanUnit"
                            label="Foto Penyerahan Unit"
                            category={this.props.isTabPelunasan ? "" : "download"}
                            value={this.props.data?.fotoPenyerahanUnitBase64}
                        />
                    </div>
                </div>
                {this.props.isUpdateActivity && (
                    <div style={{textAlign: "right", marginTop: "15px"}}>
                        {this.props.showKoreksiButton && <SimpleButton secondary>Koreksi</SimpleButton>}
                        <SimpleButton onClick={this.props.handleSave} secondary>Simpan</SimpleButton>
                    </div>
                )}
                {this.state.cancelAlert && (
                    <SimpleAlert
                        visible={this.state.cancelAlert}
                        title="Information"
                        onClickClose={() => this.handleCancelAlert(null)}
                        content={
                            <div>
                                <p>JP/TAC {parseInt(this.state.bbm.match(/\d+/)?.[0] ?? "0", 10)}</p>
                                <p>Akan DIBATALKAN, apakah anda yakin?</p>
                            </div>
                        }
                        additionalButtons={
                            <FlexView vAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton onClick={() => this.handleCancelAlert(null)}>Batal</SimpleButton>
                                <SimpleButton
                                    onClick={this.handleUncheckedBbm}>Iya</SimpleButton>
                            </FlexView>
                        }
                    />
                )}
            </>
        )
    }
}

export default DataPenagihanTab;
